import React, { useState } from "react";
import DownloadButton from "./share-buttons/DownloadButton";
import WhatsAppButton from "./share-buttons/WhatsAppButton";
import LinkButton from "./share-buttons/LinkButton";
import EmailButton from "./share-buttons/EmailButton";
import FacebookButton from "./share-buttons/FaceBookButton";
import SMSButton from "./share-buttons/SMSButton";
import styles from "./ShareBar.module.scss";
import html2canvas from "html2canvas";
import { isMobile } from "react-device-detect";

const ShareBar = (props) => {
  const mediaShareAddress = "http://" + props.cityurl + "/stories-shared-media/";
  let mediaShareURL = "";
  let shareText = "";
  let gameData = "";
  let videoTypes = ["VIDEO", "ACTION REPLAY", "LOOPCAM"];
  let azureCode = "";
  let downLoadLink = "";

  if (props.mediaShare.mediaType == "PHOTO") {
    downLoadLink = props.mediaShare.mediaURI;
    mediaShareURL = mediaShareAddress + "?u=photo/" + props.mediaShare.mediaShare + "&t=i";
    shareText = "Check%20out%20our%20photo%20from%20Electric%20Shuffle%3A%20";
  } else if (videoTypes.indexOf(props.mediaShare.mediaType) >= 0) {
    if (props.mediaShare.videoURL) {
      downLoadLink = props.mediaShare.videoURL;
      azureCode = props.mediaShare.videoURL.replace(props.azureurl, "").replace(props.bloburl, "").replace(".ism/manifest", "");
      let vidType = props.mediaShare.videoURL.includes(".mp4") ? "vidblob" : "vidaz";
      mediaShareURL = mediaShareAddress + "?u=" + vidType + "/" + azureCode + "&t=v&p=a";
    } else {
      mediaShareURL = mediaShareAddress + "?u=vidvi/" + props.mediaShare.mediaURI + "&t=v&p=v";
    }
    shareText = "Check%20out%20our%20video%20from%20Electric%20Shuffle%3A%20";
  }

  return (
    <div className={styles.ShareBar}>
      <LinkButton mediaShareURL={mediaShareURL} shareText={shareText} mediaType={props.mediaShare.mediaType} gameData={gameData} sectionName={props.mediaShare.sectionName} />
      {/* <DownloadButton mediaShareURL={downLoadLink} shareText={shareText} mediaType={props.mediaShare.mediaType} gameData={gameData} sectionName={props.mediaShare.sectionName} /> */}
      {window.location.href.indexOf("usa") != -1 && isMobile && (
        <SMSButton mediaShareURL={mediaShareURL} shareText={shareText} mediaType={props.mediaShare.mediaType} gameData={gameData} sectionName={props.mediaShare.sectionName} />
      )}
      {window.location.href.indexOf("usa") == -1 && (
        <WhatsAppButton mediaShareURL={mediaShareURL} shareText={shareText} mediaType={props.mediaShare.mediaType} gameData={gameData} sectionName={props.mediaShare.sectionName} />
      )}
      {/* <EmailButton mediaShareURL={mediaShareURL} shareText={shareText} mediaType={props.mediaShare.mediaType} gameData={gameData} sectionName={props.mediaShare.sectionName} /> */}
      <FacebookButton mediaShareURL={mediaShareURL} shareText={shareText} mediaType={props.mediaShare.mediaType} gameData={gameData} sectionName={props.mediaShare.sectionName} />
    </div>
  );
};
export default ShareBar;
